module.exports = __webpack_public_path__ + "static/media/female_right.c87a6686.jpg";